define(['jquery'], function($){
	"use strict";

	function ClusterIcon(e,t){e.getMarkerClusterer().extend(ClusterIcon,google.maps.OverlayView);this.cluster_=e;this.className_=e.getMarkerClusterer().getClusterClass();this.styles_=t;this.center_=null;this.div_=null;this.sums_=null;this.visible_=false;this.setMap(e.getMap())}function Cluster(e){this.markerClusterer_=e;this.map_=e.getMap();this.gridSize_=e.getGridSize();this.minClusterSize_=e.getMinimumClusterSize();this.averageCenter_=e.getAverageCenter();this.printable_=e.getPrintable();this.markers_=[];this.center_=null;this.bounds_=null;this.clusterIcon_=new ClusterIcon(this,e.getStyles())}function MarkerClusterer(e,t,n){this.extend(MarkerClusterer,google.maps.OverlayView);t=t||[];n=n||{};this.markers_=[];this.clusters_=[];this.listeners_=[];this.activeMap_=null;this.ready_=false;this.gridSize_=n.gridSize||60;this.minClusterSize_=n.minimumClusterSize||2;this.maxZoom_=n.maxZoom||null;this.styles_=n.styles||[];this.title_=n.title||"";this.zoomOnClick_=true;if(n.zoomOnClick!==undefined){this.zoomOnClick_=n.zoomOnClick}this.averageCenter_=false;if(n.averageCenter!==undefined){this.averageCenter_=n.averageCenter}this.ignoreHidden_=false;if(n.ignoreHidden!==undefined){this.ignoreHidden_=n.ignoreHidden}this.printable_=false;if(n.printable!==undefined){this.printable_=n.printable}this.imagePath_=n.imagePath||MarkerClusterer.IMAGE_PATH;this.imageExtension_=n.imageExtension||MarkerClusterer.IMAGE_EXTENSION;this.imageSizes_=n.imageSizes||MarkerClusterer.IMAGE_SIZES;this.calculator_=n.calculator||MarkerClusterer.CALCULATOR;this.batchSize_=n.batchSize||MarkerClusterer.BATCH_SIZE;this.batchSizeIE_=n.batchSizeIE||MarkerClusterer.BATCH_SIZE_IE;this.clusterClass_=n.clusterClass||"cluster";if(navigator.userAgent.toLowerCase().indexOf("msie")!==-1){this.batchSize_=this.batchSizeIE_}this.setupStyles_();this.addMarkers(t,true);this.setMap(e)}ClusterIcon.prototype.onAdd=function(){var e=this;var t;var n;this.div_=document.createElement("div");this.div_.className=this.className_;if(this.visible_){this.show()}this.getPanes().overlayMouseTarget.appendChild(this.div_);google.maps.event.addListener(this.getMap(),"bounds_changed",function(){n=t});google.maps.event.addDomListener(this.div_,"mousedown",function(){t=true;n=false});google.maps.event.addDomListener(this.div_,"click",function(r){t=false;if(!n){var i;var s;var o=e.cluster_.getMarkerClusterer();google.maps.event.trigger(o,"click",e.cluster_);google.maps.event.trigger(o,"clusterclick",e.cluster_);if(o.getZoomOnClick()){s=o.getMaxZoom();i=e.cluster_.getBounds();o.getMap().fitBounds(i);setTimeout(function(){o.getMap().fitBounds(i);if(s!==null&&o.getMap().getZoom()>s){o.getMap().setZoom(s+1)}},100)}r.cancelBubble=true;if(r.stopPropagation){r.stopPropagation()}}});google.maps.event.addDomListener(this.div_,"mouseover",function(){var t=e.cluster_.getMarkerClusterer();google.maps.event.trigger(t,"mouseover",e.cluster_)});google.maps.event.addDomListener(this.div_,"mouseout",function(){var t=e.cluster_.getMarkerClusterer();google.maps.event.trigger(t,"mouseout",e.cluster_)})};ClusterIcon.prototype.onRemove=function(){if(this.div_&&this.div_.parentNode){this.hide();google.maps.event.clearInstanceListeners(this.div_);this.div_.parentNode.removeChild(this.div_);this.div_=null}};ClusterIcon.prototype.draw=function(){if(this.visible_){var e=this.getPosFromLatLng_(this.center_);this.div_.style.top=e.y+"px";this.div_.style.left=e.x+"px"}};ClusterIcon.prototype.hide=function(){if(this.div_){this.div_.style.display="none"}this.visible_=false};ClusterIcon.prototype.show=function(){if(this.div_){var e=this.getPosFromLatLng_(this.center_);this.div_.style.cssText=this.createCss(e);if(this.cluster_.printable_){this.div_.innerHTML="<img src='"+this.url_+"'><div style='position: absolute; top: 0px; left: 0px; width: "+this.width_+"px;'>"+this.sums_.text+"</div>"}else{this.div_.innerHTML=this.sums_.text}if(typeof this.sums_.title==="undefined"||this.sums_.title===""){this.div_.title=this.cluster_.getMarkerClusterer().getTitle()}else{this.div_.title=this.sums_.title}this.div_.style.display=""}this.visible_=true};ClusterIcon.prototype.useStyle=function(e){this.sums_=e;var t=Math.max(0,e.index-1);t=Math.min(this.styles_.length-1,t);var n=this.styles_[t];this.url_=n.url;this.height_=n.height;this.width_=n.width;this.anchor_=n.anchor;this.anchorIcon_=n.anchorIcon||[parseInt(this.height_/2,10),parseInt(this.width_/2,10)];this.textColor_=n.textColor||"black";this.textSize_=n.textSize||11;this.textDecoration_=n.textDecoration||"none";this.fontWeight_=n.fontWeight||"bold";this.fontStyle_=n.fontStyle||"normal";this.fontFamily_=n.fontFamily||"Arial,sans-serif";this.backgroundPosition_=n.backgroundPosition||"0 0";this.margin_=n.margin||"0"};ClusterIcon.prototype.setCenter=function(e){this.center_=e};ClusterIcon.prototype.createCss=function(e){var t=[];if(!this.cluster_.printable_){t.push("background-image:url("+this.url_+");");t.push("background-position:"+this.backgroundPosition_+";")}if(typeof this.anchor_==="object"){if(typeof this.anchor_[0]==="number"&&this.anchor_[0]>=0&&this.anchor_[0]<this.height_){t.push("height:"+(this.height_-this.anchor_[0])+"px; padding-top:"+this.anchor_[0]+"px;")}else{t.push("height:"+this.height_+"px; line-height:"+this.height_+"px;")}if(typeof this.anchor_[1]==="number"&&this.anchor_[1]>=0&&this.anchor_[1]<this.width_){t.push("width:"+(this.width_-this.anchor_[1])+"px; padding-left:"+this.anchor_[1]+"px;")}else{t.push("width:"+this.width_+"px; text-align:center;")}}else{t.push("height:"+this.height_+"px; line-height:"+this.height_+"px; width:"+this.width_+"px; text-align:center;")}t.push("cursor:pointer; color:"+this.textColor_+"; position:absolute; font-size:"+this.textSize_+"px; font-family:"+this.fontFamily_+"; font-weight:"+this.fontWeight_+"; font-style:"+this.fontStyle_+"; text-decoration:"+this.textDecoration_+"; margin:"+this.margin_+";");return t.join("")};ClusterIcon.prototype.getPosFromLatLng_=function(e){var t=this.getProjection().fromLatLngToDivPixel(e);t.x-=this.anchorIcon_[1];t.y-=this.anchorIcon_[0];return t};Cluster.prototype.getSize=function(){return this.markers_.length};Cluster.prototype.getMarkers=function(){return this.markers_};Cluster.prototype.getCenter=function(){return this.center_};Cluster.prototype.getMap=function(){return this.map_};Cluster.prototype.getMarkerClusterer=function(){return this.markerClusterer_};Cluster.prototype.getBounds=function(){var e;var t=new google.maps.LatLngBounds(this.center_,this.center_);var n=this.getMarkers();for(e=0;e<n.length;e++){t.extend(n[e].getPosition())}return t};Cluster.prototype.remove=function(){this.clusterIcon_.setMap(null);this.markers_=[];delete this.markers_};Cluster.prototype.addMarker=function(e){var t;var n;var r;if(this.isMarkerAlreadyAdded_(e)){return false}if(!this.center_){this.center_=e.getPosition();this.calculateBounds_()}else{if(this.averageCenter_){var i=this.markers_.length+1;var s=(this.center_.lat()*(i-1)+e.getPosition().lat())/i;var o=(this.center_.lng()*(i-1)+e.getPosition().lng())/i;this.center_=new google.maps.LatLng(s,o);this.calculateBounds_()}}e.isAdded=true;this.markers_.push(e);n=this.markers_.length;r=this.markerClusterer_.getMaxZoom();if(r!==null&&this.map_.getZoom()>r){if(e.getMap()!==this.map_){e.setMap(this.map_)}}else if(n<this.minClusterSize_){if(e.getMap()!==this.map_){e.setMap(this.map_)}}else if(n===this.minClusterSize_){for(t=0;t<n;t++){this.markers_[t].setMap(null)}}else{e.setMap(null)}this.updateIcon_();return true};Cluster.prototype.isMarkerInClusterBounds=function(e){return this.bounds_.contains(e.getPosition())};Cluster.prototype.calculateBounds_=function(){var e=new google.maps.LatLngBounds(this.center_,this.center_);this.bounds_=this.markerClusterer_.getExtendedBounds(e)};Cluster.prototype.updateIcon_=function(){var e=this.markers_.length;var t=this.markerClusterer_.getMaxZoom();if(t!==null&&this.map_.getZoom()>t){this.clusterIcon_.hide();return}if(e<this.minClusterSize_){this.clusterIcon_.hide();return}var n=this.markerClusterer_.getStyles().length;var r=this.markerClusterer_.getCalculator()(this.markers_,n);this.clusterIcon_.setCenter(this.center_);this.clusterIcon_.useStyle(r);this.clusterIcon_.show()};Cluster.prototype.isMarkerAlreadyAdded_=function(e){var t;if(this.markers_.indexOf){return this.markers_.indexOf(e)!==-1}else{for(t=0;t<this.markers_.length;t++){if(e===this.markers_[t]){return true}}}return false};MarkerClusterer.prototype.onAdd=function(){var e=this;this.activeMap_=this.getMap();this.ready_=true;this.repaint();this.listeners_=[google.maps.event.addListener(this.getMap(),"zoom_changed",function(){e.resetViewport_(false);if(this.getZoom()===(this.get("minZoom")||0)||this.getZoom()===this.get("maxZoom")){google.maps.event.trigger(this,"idle")}}),google.maps.event.addListener(this.getMap(),"idle",function(){e.redraw_()})]};MarkerClusterer.prototype.onRemove=function(){var e;for(e=0;e<this.markers_.length;e++){if(this.markers_[e].getMap()!==this.activeMap_){this.markers_[e].setMap(this.activeMap_)}}for(e=0;e<this.clusters_.length;e++){this.clusters_[e].remove()}this.clusters_=[];for(e=0;e<this.listeners_.length;e++){google.maps.event.removeListener(this.listeners_[e])}this.listeners_=[];this.activeMap_=null;this.ready_=false};MarkerClusterer.prototype.draw=function(){};MarkerClusterer.prototype.setupStyles_=function(){var e,t,n;if(this.styles_.length>0){return}for(e=0;e<this.imageSizes_.length;e++){t=this.imageSizes_[e][0];n=this.imageSizes_[e][1];this.styles_.push({url:this.imagePath_+(e+1)+"."+this.imageExtension_,height:n,width:t})}};MarkerClusterer.prototype.fitMapToMarkers=function(){var e;var t=this.getMarkers();var n=new google.maps.LatLngBounds;for(e=0;e<t.length;e++){n.extend(t[e].getPosition())}this.getMap().fitBounds(n)};MarkerClusterer.prototype.getGridSize=function(){return this.gridSize_};MarkerClusterer.prototype.setGridSize=function(e){this.gridSize_=e};MarkerClusterer.prototype.getMinimumClusterSize=function(){return this.minClusterSize_};MarkerClusterer.prototype.setMinimumClusterSize=function(e){this.minClusterSize_=e};MarkerClusterer.prototype.getMaxZoom=function(){return this.maxZoom_};MarkerClusterer.prototype.setMaxZoom=function(e){this.maxZoom_=e};MarkerClusterer.prototype.getStyles=function(){return this.styles_};MarkerClusterer.prototype.setStyles=function(e){this.styles_=e};MarkerClusterer.prototype.getTitle=function(){return this.title_};MarkerClusterer.prototype.setTitle=function(e){this.title_=e};MarkerClusterer.prototype.getZoomOnClick=function(){return this.zoomOnClick_};MarkerClusterer.prototype.setZoomOnClick=function(e){this.zoomOnClick_=e};MarkerClusterer.prototype.getAverageCenter=function(){return this.averageCenter_};MarkerClusterer.prototype.setAverageCenter=function(e){this.averageCenter_=e};MarkerClusterer.prototype.getIgnoreHidden=function(){return this.ignoreHidden_};MarkerClusterer.prototype.setIgnoreHidden=function(e){this.ignoreHidden_=e};MarkerClusterer.prototype.getImageExtension=function(){return this.imageExtension_};MarkerClusterer.prototype.setImageExtension=function(e){this.imageExtension_=e};MarkerClusterer.prototype.getImagePath=function(){return this.imagePath_};MarkerClusterer.prototype.setImagePath=function(e){this.imagePath_=e};MarkerClusterer.prototype.getImageSizes=function(){return this.imageSizes_};MarkerClusterer.prototype.setImageSizes=function(e){this.imageSizes_=e};MarkerClusterer.prototype.getCalculator=function(){return this.calculator_};MarkerClusterer.prototype.setCalculator=function(e){this.calculator_=e};MarkerClusterer.prototype.getPrintable=function(){return this.printable_};MarkerClusterer.prototype.setPrintable=function(e){this.printable_=e};MarkerClusterer.prototype.getBatchSizeIE=function(){return this.batchSizeIE_};MarkerClusterer.prototype.setBatchSizeIE=function(e){this.batchSizeIE_=e};MarkerClusterer.prototype.getClusterClass=function(){return this.clusterClass_};MarkerClusterer.prototype.setClusterClass=function(e){this.clusterClass_=e};MarkerClusterer.prototype.getMarkers=function(){return this.markers_};MarkerClusterer.prototype.getTotalMarkers=function(){return this.markers_.length};MarkerClusterer.prototype.getClusters=function(){return this.clusters_};MarkerClusterer.prototype.getTotalClusters=function(){return this.clusters_.length};MarkerClusterer.prototype.addMarker=function(e,t){this.pushMarkerTo_(e);if(!t){this.redraw_()}};MarkerClusterer.prototype.addMarkers=function(e,t){var n;for(n=0;n<e.length;n++){this.pushMarkerTo_(e[n])}if(!t){this.redraw_()}};MarkerClusterer.prototype.pushMarkerTo_=function(e){if(e.getDraggable()){var t=this;google.maps.event.addListener(e,"dragend",function(){if(t.ready_){this.isAdded=false;t.repaint()}})}e.isAdded=false;this.markers_.push(e)};MarkerClusterer.prototype.removeMarker=function(e,t){var n=this.removeMarker_(e);if(!t&&n){this.repaint()}return n};MarkerClusterer.prototype.removeMarkers=function(e,t){var n,r;var i=false;for(n=0;n<e.length;n++){r=this.removeMarker_(e[n]);i=i||r}if(!t&&i){this.repaint()}return i};MarkerClusterer.prototype.removeMarker_=function(e){var t;var n=-1;if(this.markers_.indexOf){n=this.markers_.indexOf(e)}else{for(t=0;t<this.markers_.length;t++){if(e===this.markers_[t]){n=t;break}}}if(n===-1){return false}e.setMap(null);this.markers_.splice(n,1);return true};MarkerClusterer.prototype.clearMarkers=function(){this.resetViewport_(true);this.markers_=[]};MarkerClusterer.prototype.repaint=function(){var e=this.clusters_.slice();this.clusters_=[];this.resetViewport_(false);this.redraw_();setTimeout(function(){var t;for(t=0;t<e.length;t++){e[t].remove()}},0)};MarkerClusterer.prototype.getExtendedBounds=function(e){var t=this.getProjection();var n=new google.maps.LatLng(e.getNorthEast().lat(),e.getNorthEast().lng());var r=new google.maps.LatLng(e.getSouthWest().lat(),e.getSouthWest().lng());var i=t.fromLatLngToDivPixel(n);i.x+=this.gridSize_;i.y-=this.gridSize_;var s=t.fromLatLngToDivPixel(r);s.x-=this.gridSize_;s.y+=this.gridSize_;var o=t.fromDivPixelToLatLng(i);var u=t.fromDivPixelToLatLng(s);e.extend(o);e.extend(u);return e};MarkerClusterer.prototype.redraw_=function(){this.createClusters_(0)};MarkerClusterer.prototype.resetViewport_=function(e){var t,n;for(t=0;t<this.clusters_.length;t++){this.clusters_[t].remove()}this.clusters_=[];for(t=0;t<this.markers_.length;t++){n=this.markers_[t];n.isAdded=false;if(e){n.setMap(null)}}};MarkerClusterer.prototype.distanceBetweenPoints_=function(e,t){var n=6371;var r=(t.lat()-e.lat())*Math.PI/180;var i=(t.lng()-e.lng())*Math.PI/180;var s=Math.sin(r/2)*Math.sin(r/2)+Math.cos(e.lat()*Math.PI/180)*Math.cos(t.lat()*Math.PI/180)*Math.sin(i/2)*Math.sin(i/2);var o=2*Math.atan2(Math.sqrt(s),Math.sqrt(1-s));var u=n*o;return u};MarkerClusterer.prototype.isMarkerInBounds_=function(e,t){return t.contains(e.getPosition())};MarkerClusterer.prototype.addToClosestCluster_=function(e){var t,n,r,i;var s=4e4;var o=null;for(t=0;t<this.clusters_.length;t++){r=this.clusters_[t];i=r.getCenter();if(i){n=this.distanceBetweenPoints_(i,e.getPosition());if(n<s){s=n;o=r}}}if(o&&o.isMarkerInClusterBounds(e)){o.addMarker(e)}else{r=new Cluster(this);r.addMarker(e);this.clusters_.push(r)}};MarkerClusterer.prototype.createClusters_=function(e){var t,n;var r;var i=this;if(!this.ready_){return}if(e===0){google.maps.event.trigger(this,"clusteringbegin",this);if(typeof this.timerRefStatic!=="undefined"){clearTimeout(this.timerRefStatic);delete this.timerRefStatic}}if(this.getMap().getZoom()>3){r=new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),this.getMap().getBounds().getNorthEast())}else{r=new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472,-178.48388434375),new google.maps.LatLng(-85.08136444384544,178.00048865625))}var s=this.getExtendedBounds(r);var o=Math.min(e+this.batchSize_,this.markers_.length);for(t=e;t<o;t++){n=this.markers_[t];if(!n.isAdded&&this.isMarkerInBounds_(n,s)){if(!this.ignoreHidden_||this.ignoreHidden_&&n.getVisible()){this.addToClosestCluster_(n)}}}if(o<this.markers_.length){this.timerRefStatic=setTimeout(function(){i.createClusters_(o)},0)}else{delete this.timerRefStatic;google.maps.event.trigger(this,"clusteringend",this)}};MarkerClusterer.prototype.extend=function(e,t){return function(e){var t;for(t in e.prototype){this.prototype[t]=e.prototype[t]}return this}.apply(e,[t])};MarkerClusterer.CALCULATOR=function(e,t){var n=0;var r="";var i=e.length.toString();var s=i;while(s!==0){s=parseInt(s/10,10);n++}n=Math.min(n,t);return{text:i,index:n,title:r}};MarkerClusterer.BATCH_SIZE=2e3;MarkerClusterer.BATCH_SIZE_IE=500;MarkerClusterer.IMAGE_PATH="http://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclustererplus/images/m";MarkerClusterer.IMAGE_EXTENSION="png";MarkerClusterer.IMAGE_SIZES=[[53,53],[56,56],[66,66],[78,78],[90,90]];

	var MAP_TYPE = {
		HYBRID: google.maps.MapTypeId.HYBRID,
		TERRAIN: google.maps.MapTypeId.TERRAIN,
		ROADMAP: google.maps.MapTypeId.ROADMAP,
		SATELLITE: google.maps.MapTypeId.SATELLITE
	};

	var PLUGIN_NAME = "googlemap";
	var PLUGIN_VERSION = "v0.9";

	var	DEFAULTS = {
		width: 						null,
		height: 					null,
		mapOptions:					{
			startingPosition:			{
				lat:						49.773811,
				lng:						15.771272,
				zoom:						7
			},
			mapTypeControl:				true,
			mapTypeId:					MAP_TYPE.ROADMAP,
			scaleControl:				true,
			panControl:					true,
			streetViewControl:			true,
			zoomControl:				true,
			maxZoom:					null,
			minZoom:					null,
			scrollwheel:				true
		},
		markerTypes:					[],
		showAllMarkersOnEmptyFilter:	true,
		clustering:						{
			enabled:						false,
			mode:							'allInOne',
			categories:						[],
			iconsStyles:					[],
			maxZoom:						null,
			batchSize:						2000,
			batchSizeIE:					500
		},
		oneBubbleAtOnce:				true,
		bubbleContentFormatter:		function(mData) {
			var str = '';
			if (mData.title) { str += '<h3>'+mData.title+'</h3>'; }

			return str;
		}

	};

	// The actual plugin constructor
	var GoogleMap = function ( element, options ) {
		this.element = element;

		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;
		this.initialise();
	};

	/**
	 * init function
	 */
	GoogleMap.prototype.initialise = function() {
		var o = this.options;

		// set given height, width ... if not given, dimensions will be taken from CSS
		if (o.width && o.height) {
			$(this.element).css({
				'width' : o.width+'px',
				'height' : o.height+'px'
			});
		}
		google.maps.visualRefresh = false;
		this.buildMap();
		this._kmlLayers = [];
		this._generatedPaths = [];
		this._markersData = [];
		this._generatedMarkers = [];
		this._generatedInfoWindows = [];
		this._clusterers = [];
		this._mapListeners = [];
		this._customMarkers = [];
	};

	/**
	 * support function
	 */
	GoogleMap.prototype.getObjectLength = function(obj) {
		var cnt = 0;
		for (var x in obj) {
			if (obj.hasOwnProperty(x)) {
				cnt++;
			}
		}
		return cnt;
	};

	/**
	 * renders map and saves its reference to GoogleMap object
	 */
	GoogleMap.prototype.buildMap = function() {
		var o = this.options;
		this._gmap = new google.maps.Map(this.element, {
			zoom: o.mapOptions.startingPosition.zoom,
			center: new google.maps.LatLng(o.mapOptions.startingPosition.lat, o.mapOptions.startingPosition.lng),
			mapTypeControl : o.mapOptions.mapTypeControl,
			mapTypeId: MAP_TYPE[o.mapOptions.mapTypeId] || o.mapOptions.mapTypeId,
			scaleControl : o.mapOptions.scaleControl,
			panControl : o.mapOptions.panControl,
			streetViewControl : o.mapOptions.streetViewControl,
			zoomControl: o.mapOptions.zoomControl,
			maxZoom: o.mapOptions.maxZoom,
			minZoom: o.mapOptions.minZoom,
			scrollwheel: o.mapOptions.scrollwheel
		});
	};

	/**
	 * loads data to this._markersData[collectionId] and executes callback, if given
	 * @param params - object with:
	 * 	collectionId - load and store data into this collection
	 * 	data - pure data
	 * 	dataUrl - ajax url to get data (JSON)
	 * 	postData - data passed to JSON request
	 * 	callback - execute callback after data is loaded
	 */
	GoogleMap.prototype.loadMarkers = function(params) {
		var _self = this;
		var collectionId = params.collectionId || 'default';
		var filter = params.initialFilter || {};
		var postData = params.postData || {};
		var listeners = params.listeners || null;
		this.clearMarkersAndInfoWindows(collectionId);
		if (params.dataUrl) {

			var dataSetName = params.dataSetName || 'markers';

			$.getJSON(params.dataUrl, postData, function(dt) {
				if (dt && dt[dataSetName].length > 0) {
					_self._markersData[collectionId] = dt[dataSetName].slice(0);
					if (typeof(params.render) == "undefined" || params.render) {
						_self.renderMarkers({
							collectionId: collectionId,
							initialFilter: filter,
							listeners: listeners
						});
					}
				}

				if ($.isFunction(params.callback)) {
					params.callback.call(_self);
				}
			});

		} else if ($.isArray(params.data)) {
			this._markersData[collectionId] = params.data.slice(0);

			if (typeof(params.render) == "undefined" || params.render) {
				this.renderMarkers({
					collectionId: collectionId,
					initialFilter: filter,
					listeners: listeners
				});
			}

			if ($.isFunction(params.callback)) {
				params.callback.call(_self);
			}
		}
	};

	/**
	 * gets array of objects (markers) and renders them to the map
	 * @param params - object with:
	 *	collectionId - render only markers within this collection. If null, render all collections
	 * 	initialFilter - object of properties rules, which are applied to rendered marker - if it is visible or not
	 */
	GoogleMap.prototype.renderMarkers = function(params) {
    	var o = this.options;

		if (params.collectionId && $.isArray(this._markersData[params.collectionId])) {
			this.processMarkers(params.collectionId, this._markersData[params.collectionId], params.listeners);
		} else {
			for (var collection in this._markersData) {
				if (this._markersData.hasOwnProperty(collection)) {
					this.processMarkers(collection, this._markersData[collection], params.listeners);
				}
			}
		}

		if (o.clustering.enabled) {
			this._clusterers = [];
			this._clusterers.push(new MarkerClusterer(this._gmap, this._generatedMarkers, {
				averageCenter: true,
				ignoreHidden: true,
				styles: o.clustering.iconsStyles,
				maxZoom: o.clustering.maxZoom,
				batchSize: o.clustering.batchSize,
				batchSizeIE: o.clustering.batchSizeIE
			}));
		}

		if (params.initialFilter && this.getObjectLength(params.initialFilter) > 0) {
			this.filterMarkers(params.initialFilter);
		}

	};

	//GoogleMap.prototype.processMarker = function(lat, lng, type, title, bubbleContent, filter, fulltextData) {
	GoogleMap.prototype.processMarkers = function(collectionId, markersData, listeners) {
		var o = this.options;
		var self = this;
		var bubbleContent = '';
		var marker, infowindow;

		for (var i=0; i<markersData.length; i++) {

			if ($.isFunction(o.bubbleContentFormatter)) {
				bubbleContent = o.bubbleContentFormatter(markersData[i]);
			}

			marker = new google.maps.Marker({
				position: new google.maps.LatLng(markersData[i].lat, markersData[i].lng),
				map: this._gmap,
				title: markersData[i].title,
				cursor: (bubbleContent && bubbleContent != "") ? 'pointer' : 'default',
				type: markersData[i].type,
				visible: (o.showAllMarkersOnEmptyFilter && (this.getObjectLength(o.initialFilter) == 0)),
				filter: markersData[i].filter,
				fulltextData: markersData[i].fulltextData,
				collectionId: collectionId,
				icon: (o.markerTypes.length > 0 && typeof(o.markerTypes[markersData[i].type]) == "object") ? o.markerTypes[markersData[i].type].icon : null,
				shadow: (o.markerTypes.length > 0 && typeof(o.markerTypes[markersData[i].type]) == "object") ? o.markerTypes[markersData[i].type].shadow : null,
				shape: (o.markerTypes.length > 0 && typeof(o.markerTypes[markersData[i].type]) == "object") ? o.markerTypes[markersData[i].type].shape : null
			});

			if (listeners) {
				for (var listener in listeners) {
					if (listeners.hasOwnProperty(listener)) {
						this.processMarkersCustomAction(marker, listener, listeners[listener], markersData[i]);
					}
				}
			} else {
				infowindow = this.createInfowindow(marker, bubbleContent, collectionId);
				this._generatedInfoWindows.push(infowindow);
			}

			this._generatedMarkers.push(marker);

		}

		return true;
	};

	GoogleMap.prototype.createInfowindow = function(marker, bubbleContent, collectionId) {
		var infowindow;
		var self = this;
		var o = this.options;
		if (bubbleContent && bubbleContent != "") {
			infowindow = new google.maps.InfoWindow({
				content: bubbleContent
			});

			infowindow.collectionId = collectionId;

			google.maps.event.addListener(marker, 'click', function() {
				if (o.oneBubbleAtOnce) {
					self.closeInfoWindows();
				}
				infowindow.open(self._gmap, marker);
			});
		}

		return infowindow;

	};

	GoogleMap.prototype.processMarkersCustomAction = function(marker, listenerType, listenerAction, markersData) {
		google.maps.event.addListener(marker, listenerType, function(event) {
			listenerAction.call(self, markersData);
		});
	};

	/**
	 * place custom marker with options in params
	 * @param params
	 * - id
	 * - latitude
	 * - longitude
	 * - title
	 * - draggable
	 */
	GoogleMap.prototype.placeCustomMarker = function(params) {
		var o = this.options;
		var id = params.id || this._customMarkers.length++;

		if (typeof(this._customMarkers[params.id]) == "object") {
			this.removeCustomMarker({
				id: params.id
			});
		}

		var marker = new google.maps.Marker({
			position: new google.maps.LatLng(params.latitude, params.longitude),
			map: this._gmap,
			id: params.id,
			title: params.title || '',
			cursor: 'move',
			visible: true,
			draggable: params.draggable || false,
			icon: params.iconType ? o.markerTypes[params.iconType].icon : null,
			shadow: params.iconType ? o.markerTypes[params.iconType].shadow: null,
			shape: params.iconType ? o.markerTypes[params.iconType].shape: null
		});

		for (var listener in params.listeners) {
			if (params.listeners.hasOwnProperty(listener)) {
				this.bindEventToCustomMarker(marker, listener, params.listeners[listener]);
			}
		}

		if (params.zIndex) {
			marker.setZIndex(params.zIndex);
		}

		this._customMarkers[params.id] = marker;
	};
	/**
	 * helper function to placeCustomMarker - prevent mutable variable
	 * @param target
	 * @param eventType
	 * @param fnc
	 */
	GoogleMap.prototype.bindEventToCustomMarker = function(target, eventType, fnc) {
		var self = this;
		google.maps.event.addListener(target, eventType, function(event) {
			fnc.call(self, event.latLng.lat(), event.latLng.lng());
		});
	};

	/**
	 * remove custom placed marker by id
	 */
	GoogleMap.prototype.removeCustomMarker = function(params) {
		if (!this._customMarkers[params.id]) {
			return false;
		}
		this._customMarkers[params.id].setMap(null);
		this._customMarkers[params.id] = null;
		return true;
	};

	/**
	 * goes through generated markers and enables / disables its visibility according to the filter
	 * @param filter
	 */
	GoogleMap.prototype.filterMarkers = function(filter) {
		var o = this.options;

		if (!this._generatedMarkers || this._generatedMarkers.length == 0) {
			return false;
		}
		this.closeInfoWindows();

		var currentMarkerVisibilityByCategory, currentMarkerVisible, markerFilter, markerFulltextData;
		for (var i=0; i<this._generatedMarkers.length; i++) {

			if (!o.showAllMarkersOnEmptyFilter && this.getObjectLength(filter) == 0) {
				this._generatedMarkers[i].setVisible(false);
				continue;
			}

			markerFilter = this._generatedMarkers[i].filter;
			markerFulltextData = this._generatedMarkers[i].fulltextData;
			currentMarkerVisibilityByCategory = [];
			for (var filterGroup in filter) {
				if (!filter.hasOwnProperty(filterGroup) || filter[filterGroup].length == 0) { continue; }

				currentMarkerVisibilityByCategory[filterGroup] = false;

				if ($.isArray(filter[filterGroup])) {
					if (!markerFilter[filterGroup]) {
						continue;
					}

					for (var i2=0; i2 < filter[filterGroup].length; i2++) {
						if ($.inArray(filter[filterGroup][i2], markerFilter[filterGroup]) > -1) {
							currentMarkerVisibilityByCategory[filterGroup] = true;
						}
					}
				} else if (typeof(filter[filterGroup]) == "string") {
					if (!markerFulltextData[filterGroup]) {
						continue;
					}
					if (markerFulltextData[filterGroup].toLowerCase().indexOf(filter[filterGroup].toLowerCase()) > -1) {
						currentMarkerVisibilityByCategory[filterGroup] = true;
					}
				}
			}

			currentMarkerVisible = true;
			for (var resultGroup in currentMarkerVisibilityByCategory) {
				if (currentMarkerVisibilityByCategory.hasOwnProperty(resultGroup)) {
					currentMarkerVisible = currentMarkerVisible & currentMarkerVisibilityByCategory[resultGroup];
				}
			}

			if (currentMarkerVisible) {
				this._generatedMarkers[i].setVisible(true);
			} else {
				this._generatedMarkers[i].setVisible(false);
			}
		}

		if (o.clustering.enabled && o.clustering.mode == 'allInOne' && this._clusterers.length > 0) {
			for (var j=0; j<this._clusterers.length; j++) {
				this._clusterers[j].repaint();
			}
		}
	};

	/**
	 *
	 */
	GoogleMap.prototype.clearMarkersAndInfoWindows = function(collectionId) {
		var o = this.options;
		var markersToRemove = [];
		if (!this._markersData[collectionId]) {
			return true;
		}

		var i;
		for (i=0; i<this._generatedInfoWindows.length; i++) {
			if (this._generatedInfoWindows[i].collectionId == collectionId) {
				this._generatedInfoWindows[i].close();
				this._generatedInfoWindows.splice(i,1);
				i--;
			}
		}

		for (i=0; i<this._generatedMarkers.length; i++) {
			if (this._generatedMarkers[i].collectionId == collectionId) {
				this._generatedMarkers[i].setMap(null);
				markersToRemove.push(this._generatedMarkers[i]);
				this._generatedMarkers.splice(i,1);
				i--;
			}
		}
		if (o.clustering.enabled && o.clustering.mode == 'allInOne' && this._clusterers.length > 0) {
			for (var j=0; j<this._clusterers.length; j++) {
				this._clusterers[j].removeMarkers(markersToRemove);
			}
		}

		this._markersData[collectionId] = [];

		return true;
	};

	/**
	 * closes all generated infoWindows
	 */
	GoogleMap.prototype.closeInfoWindows = function() {
		for (var i=0; i<this._generatedInfoWindows.length; i++) {
			if (this._generatedInfoWindows[i] !== null) {
				this._generatedInfoWindows[i].close();
			}
		}
	};

	/**
	 * sets center and zoom to the current map
	 * @param params - object with properties:
	 *  - latitude
	 *  - longitude
	 *  - zoom
	 */
	GoogleMap.prototype.setCenterAndZoom = function(params) {
		this._gmap.setCenter(new google.maps.LatLng(params.latitude, params.longitude));
		this._gmap.setZoom(params.zoom);
	};

	/**
	 * changes map type
	 * @param type
	 */
	GoogleMap.prototype.setMapType = function(type) {
		this._gmap.setMapTypeId(MAP_TYPE[type] || type);
	};

	/**
	 * external map type setup
	 * @param options - object of options https://developers.google.com/maps/documentation/javascript/reference#MapOptions
	 */
	GoogleMap.prototype.setOptions = function(options) {
		this._gmap.setOptions(options);
	};

	/**
	 * renders a path on map
	 * @param pathData - array of google coordinates [new google.maps.LatLng(50.1116210001872,14.6206970146592),new google.maps.LatLng(50.1116788214025,14.6209640760919)...]
	 * @param pathColor - hexacolor of the path
	 * @param pathWidth - width in pixels
	 * @param pathOpacity - opacity
	 */
	GoogleMap.prototype.renderPath = function(pathData, pathColor, pathWidth, pathOpacity) {
		var path = new google.maps.Polyline({
			path: pathData,
			strokeColor: pathColor || '#f00',
			strokeOpacity: pathOpacity || 1.0,
			strokeWeight: pathWidth || '2'
		});

		path.setMap(this._gmap);
		this._generatedPaths.push(path);

	};

	/**
	 * renders layer from external KMZ (zipped KML) layer
	 * @param id
	 * @param kmzFile
	 * @param showImmediately
	 * @param cb - callback after rendering layer
	 */
	GoogleMap.prototype.renderKMZLayer = function(id, kmzFile, showImmediately, cb) {
		var kmlLayer = new google.maps.KmlLayer(kmzFile, {
			preserveViewport: true
		});
		if (showImmediately) {
			kmlLayer.setMap(this._gmap);
		} else {
			kmlLayer.setMap(null);
		}

		this._kmlLayers.push({
			id: id,
			layer: kmlLayer,
			enabled: showImmediately
		});

		if (showImmediately && $.isFunction(cb)) {
			cb.call();
		}
	};

	/**
	 * toggles kmz layer by id
	 * @param id
	 */
	GoogleMap.prototype.toggleKMZLayer = function(id) {
		var kmlLayers = this._kmlLayers;
		for (var i=0; i<kmlLayers.length; i++) {
			if (kmlLayers[i].id == id) {
				if (kmlLayers[i].enabled) {
					kmlLayers[i].layer.setMap(null);
				} else {
					kmlLayers[i].layer.setMap(this._gmap);
				}
				kmlLayers[i].enabled = !kmlLayers[i].enabled;
			}
		}
	};


	/**
	 * show address by string
	 * @param address
	 * TODO: create marker
	 */
	GoogleMap.prototype.findAndShowAddress = function(address, zoom, callback) {
		var self = this;
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode( { 'address': address}, function(results, status) {
			if (status == google.maps.GeocoderStatus.OK && results.length > 0) {
				self.setCenterAndZoom({
					latitude: results[0].geometry.location.lat(),
					longitude: results[0].geometry.location.lng(),
					zoom: zoom || 16
				});
			}

			if ($.isFunction(callback)) {
				callback.call();
			}
		});
	};

	/**
	 * adds listener to an object
	 * @param params
	 * - target - target, that listens to event
	 * - eventType - click, dblclick, mouseup, mousedown, mouseover, mouseout
	 * - function
	 */
	GoogleMap.prototype.addListener = function(params) {
		var self = this;
		var id = params.id;
		var target = null;
		var eventType = params.eventType;

		switch (params.target) {
			case "map":
				target = this._gmap;
				break;
			default:
				break;
		}

		if (!target) {
			return false;
		}

		this._mapListeners[id] = google.maps.event.addListener(target, eventType, function(event) {
			params.execute.call(self, event.latLng.lat(), event.latLng.lng());
		});
	};

	GoogleMap.prototype.removeListener = function(params) {
		google.maps.event.removeListener(this._mapListeners[params.id]);
		this._mapListeners[params.id] = null;
	};



	/**
	 * decide, which methods will be "public"
	 */
	var API = {
		setCenterAndZoom: GoogleMap.prototype.setCenterAndZoom,
		setMapType: GoogleMap.prototype.setMapType,
		setOptions: GoogleMap.prototype.setOptions,
		renderPath: GoogleMap.prototype.renderPath,
		renderKMZLayer: GoogleMap.prototype.renderKMZLayer,
		toggleKMZLayer: GoogleMap.prototype.toggleKMZLayer,
		renderMarkers: GoogleMap.prototype.renderMarkers,
		loadMarkers: GoogleMap.prototype.loadMarkers,
		filterMarkers: GoogleMap.prototype.filterMarkers,
		findAndShowAddress: GoogleMap.prototype.findAndShowAddress,
		addListener: GoogleMap.prototype.addListener,
		removeListener: GoogleMap.prototype.removeListener,
		placeCustomMarker: GoogleMap.prototype.placeCustomMarker,
		removeCustomMarker: GoogleMap.prototype.removeCustomMarker
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new GoogleMap(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};


	/**
	 * setDefaults with $.googlemap.setDefaults();
	 */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function(newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};

});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.gm.js